import { AsyncPipe, Location, NgClass, NgStyle } from '@angular/common';
import { Component, ViewChild } from "@angular/core";
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute, Data } from "@angular/router";
import { IonicModule } from '@ionic/angular';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { DocumentSnapshot } from 'firebase/firestore';
import { from, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { bounceIn, gamethumbBounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from 'src/app/app.constants';
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { InProgressAnimationComponent } from '../../../components/in-progress-animation/in-progress-animation.component';
import { GamesRepositoryService } from "../games-repository.service";
import { GameDatasService } from '../services/game-data.service';
import { GamePlayBaseComponent } from '../shared/game-play-base.component';

@Component({
  selector: "app-adventure-game",
  templateUrl: "./adventure-game.component.html",
  styleUrls: ["./adventure-game.component.scss"],
  animations: [gamethumbBounceIn, bounceIn],
  standalone: true,
  imports: [
    IonicModule,
    SwiperModule,
    NgClass,
    NgStyle,
    MatProgressSpinner,
    MatIcon,
    InProgressAnimationComponent,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class AdventureGameComponent extends GamePlayBaseComponent{
  public learnMoreDetails: string;
  public learnMoreRules: string;
  gameTotalPrize: string;
  @ViewChild(SwiperComponent) slides: SwiperComponent;
  @ViewChild("progressSlides") progressSlides: SwiperComponent;


  slidesOptions: SwiperOptions = {
    speed: 400,
    slidesPerView: 1,
    pagination: true,
  };
  defaultSlider: number = null;
  index: number;
  activeSlideIndex = 0;
  isScreenshotsAvailable = false;
  adventureShortTitle: string;
  slidesOpts: SwiperOptions = {
    effect: "fade",
    speed: 400,
    on: {
      // Use traditional function to ensure 'this' is bound correctly
      beforeInit: function () {
        const swiper = this;
        swiper.classNames.push(`${swiper?.params?.containerModifierClass}fade`);
        const overwriteParams = {
          speed: 400, // Ensure speed is defined here
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        swiper.params = Object.assign(swiper?.params, overwriteParams);
        swiper.originalParams = Object.assign(swiper?.originalParams, overwriteParams);
      },
      // Use traditional function to ensure 'this' is bound correctly
      setTranslate: function () {
        const swiper = this;
        const { slides } = swiper;
        try {
          for (let i = 0; i < slides.length; i += 1) {
            const $slideEl = swiper.slides.eq(i);
            const offset$$1 = $slideEl[0]?.swiperSlideOffset;
            let tx = -offset$$1;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
              ty = tx;
              tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs($slideEl[0]?.progress), 0)
              : 1 + Math.min(Math.max($slideEl[0]?.progress, -1), 0);
            $slideEl
              .css({
                opacity: slideOpacity,
              })
              .transform(`translate3d(${tx}px, ${ty}px, 0px)`);
          }
        } catch (e) { }
      },
      // Use traditional function to ensure 'this' is bound correctly
      setTransition: function (duration) {
        const swiper = this;
        const { slides, wrapperEl } = swiper;
        // Swiper v8+ removed jQuery-like helpers; set transitionDuration directly on each slide element
        slides.forEach((slide) => {
          slide.style.transitionDuration = `${duration}ms`;
        });
        if (swiper.params.virtualTranslate) {
          // Listen on the first slide only; once it fires, dispatch synthetic events on wrapperEl
          const firstSlide = slides[0];
          if (firstSlide) {
            const onTransitionEnd = () => {
              if (!swiper || swiper.destroyed) return;
              swiper.animating = false;
              const triggerEvents = ["webkitTransitionEnd", "transitionend"];
              for (let i = 0; i < triggerEvents.length; i += 1) {
                wrapperEl.dispatchEvent(new Event(triggerEvents[i]));
              }
            };
            firstSlide.addEventListener('transitionend', onTransitionEnd, { once: true });
          }
        }
      },
    },
  };

  touchStart(event: Event, sliderNumber: number, i: number) {
    event.preventDefault();
    event.stopPropagation();
    this.defaultSlider = i;
    this.index = i;
    this.slides?.swiperRef?.slideTo(sliderNumber, 500);
  }

  touchEnd() {
    this.defaultSlider = null;
    this.index = null;
    this.slides?.swiperRef?.slideTo(0, 500);
  }

  goToSlide() {
    this.slides?.swiperRef?.slideTo(1, 500);
  }
  goToSlide1() {
    this.slides?.swiperRef?.slideTo(2, 500);
  }
  goToSlide2() {
    this.slides?.swiperRef?.slideTo(3, 500);
  }
  goToSlide3() {
    this.slides?.swiperRef?.slideTo(4, 500);
  }
  back() {
    this.location.back();
  }
  ssSlide = {
    slidesPerView: 3,
  };
  speed: number;
  isAchievedAvailable: boolean;
  public languageCode: string;
  userGameRestriction: boolean;
  constructor(
    private gameService: GamesRepositoryService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService,
    private location: Location,
    private gameDatasService: GameDatasService,
  ) {
    super()
    this.speed = 500;
  }

  ngOnInit(): void {
    super.ngOnInit(); // ✅ REQUIRED
  }


  gameInfo$ = this.gameDatasService.getGameInfo(this.route.snapshot.params.id, "adventure").pipe(
    switchMap((snapshots: DocumentSnapshot<unknown>[]) => {
      const numberOne = 1;
      const numberZero = 0;
      const number9 = 9;
      const number10 = 10;
      const adventureGame = snapshots.map((snapshot) => snapshot.data() as any);
      const preferredCurrency = this.preferredCurrency ?? CommonVariable.preferredCurrency;
      if (adventureGame && adventureGame[numberOne]) {
        const inputData = {
          myString: adventureGame[numberOne],
          currency: preferredCurrency,
        };
        return from(this.authService.getDvResolvedJson(inputData)).pipe(
          map((resp: Data) => {
            const dvAdventureGame = resp?.data;
            let data = {} as any;
            const filterdata = adventureGame[numberOne]?.prize_content?.map((p, i) => {
              const basePrize = adventureGame[numberZero]?.prize_content?.[i];
              return {
                ...p,
                is_achieved: basePrize?.is_achieved,
                prize_no: basePrize?.prize_no,
                progress: basePrize?.progress,
              };
            }) ?? [];
            const userProgressGoal =
              adventureGame[numberOne]?.goal_content?.map((_, i) => {
                return adventureGame[numberZero]?.goal_content?.[i] ??
                  adventureGame[numberOne]?.goal_content?.[i];
              }) ?? [];
            const userProgressStar =
              adventureGame[numberZero]?.star_collected ??
              adventureGame[numberOne]?.star_collected;
            const firstSlide = userProgressGoal.slice(0, number10);
            const secondSlide = userProgressGoal.slice(number10);

            const learnMoreDetails =
              dvAdventureGame?.int_learn_more_details?.[this.selectedLanguage] ??
              dvAdventureGame?.learn_more_details;

            if (learnMoreDetails) {
              this.learnMoreDetails = learnMoreDetails;
            }
            const learnMoreRules =
              dvAdventureGame?.int_learn_more_rules?.[this.selectedLanguage] ??
              dvAdventureGame?.learn_more_rules;
            if (learnMoreRules) {
              this.learnMoreRules = learnMoreRules;
            }

            data = {
              ...dvAdventureGame,
              prize_content: filterdata,
              goal_content: [firstSlide, secondSlide],
              star_collected: userProgressStar,
            };
            const prizeContentLength = dvAdventureGame?.prize_content?.length ?? 0;
            this.isAchievedAvailable =
              dvAdventureGame?.prize_content?.some((p) => p.is_achieved) ?? false;

            if (prizeContentLength) {
              dvAdventureGame.prize_content.forEach((p, i) => {
                const prize =
                  p?.int_prize?.[this.languageCode] ?? p?.prize;
                if (prize) data.prize_content[i].prize = prize;
              });
            }
            if (dvAdventureGame?.total_prize) {
              this.gameTotalPrize =
                dvAdventureGame?.int_total_prize?.[this.languageCode] ??
                dvAdventureGame?.total_prize;
            } else {
              const currencyCodeMap = this.gameService.currencyCodeMapping;
              const code =
                currencyCodeMap[this.preferredCurrency] ||
                currencyCodeMap.default;

              this.gameTotalPrize =
                data?.country_code_data?.[code]?.total_prize ?? "";
            }
            if (dvAdventureGame?.adventure_short_title) {
              this.adventureShortTitle =
                dvAdventureGame.adventure_short_title[this.languageCode] ??
                dvAdventureGame.adventure_short_title;
            } else {
              const currencyCodeMap = this.gameService.currencyCodeMapping;
              const code =
                currencyCodeMap[this.preferredCurrency] ||
                currencyCodeMap.default;

              this.adventureShortTitle =
                data?.country_code_data?.[code]?.adventure_short_title ?? "";
            }
            this.isScreenshotsAvailable =
              Array.isArray(data?.screen_shot) &&
              data.screen_shot.some((p) => !!p);

            this.gameService.setCurrentGameOrientationStatus(data?.orientation);
            return data;
          }),
          catchError((err) => {
          
            return of({});
          })
        );
      }

      return of({});
    })
  );




  getIsNotAchieved(prize_content) {
    if (!prize_content) return;
    return prize_content.filter((data) => !data.is_achieved);
  }
  getIsAchieved(prize_content) {
    if (!prize_content) return;
    return prize_content.filter((data) => data.is_achieved);
  }
  async playGame(game: any) {
    if (!this.userGameRestriction) {
      this.isButtonDisabled = true;
      this.GTMSegment.HotJarEvent("user_played_game");
      if (!window.navigator.onLine) return;
      game.document = "/api_post_request/customer_game_token_authentication";
      game.from_page = "adventure";
      game.user_game_restriction = this.userGameRestriction;
      this.playGameBase(game)
    } else {
      this.isButtonDisabled = false;
      // this.authGamesService?.callDedicatedInboxMessage();
      this.authService.getConstantsMsg("1148")
        .then((translatedMsg) => {
          const message = "You have reached the game play limit";
          const defaultMsg = {
            message: {
              line_1: message,
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  getIsAchivedSection(prize_content: Array<any>) {
    if (!prize_content) return false;
    return prize_content.filter((ele) => ele.is_achieved).length > 0 ? true : false;
  }
  slidePrev() {
    try {
      this.progressSlides?.swiperRef?.slidePrev(this.speed);
    } catch (e) { }
  }
  slideNext() {
    try {
      this.progressSlides?.swiperRef?.slideNext(this.speed);
    } catch (e) { }
  }
}
